import { useMemo } from 'react'
import { tsScreen } from '../../../Typescript/DB_Interface'

export function useSummariseStatus(screen: tsScreen | undefined) {
  return useMemo(() => {
    const statSumm: any = {}
    if (screen?.Collections) {
      screen.Collections.forEach((item) => {
        if (statSumm?.[item.Status]) {
          statSumm[item.Status] = statSumm[item.Status] + 1
        } else {
          statSumm[item.Status] = 1
        }
      })
    }
    return Object.entries(statSumm).map(([status, count]) => {
      return { Status: status, Total: count }
    })
  }, [screen])
}
